module.exports = __webpack_public_path__ + "static/media/IMG_5067.effb3833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/IMG_5067.jpg
// module id = 493
// module chunks = 0